
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#1E196A","stroke-width":"2.4","fill":"none","fill-rule":"evenodd","stroke-linecap":"square"}},[_c('path',{attrs:{"d":"M13.94 2.06L2.06 13.94M2.06 2.06l11.88 11.88"}})])])
      }
    
      }
    